import React from 'react';
export function GuaranteeSection() {
  return <section className="bg-neutral-bg py-10 px-4 sm:px-6 lg:px-8 border-y border-neutral-beige" data-id="element-36">
      <div className="max-w-4xl mx-auto" data-id="element-37">
        <div className="bg-white rounded-3xl p-6 sm:p-8 border border-neutral-beige shadow-lg text-center flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8 transform transition-transform hover:-translate-y-1" data-id="element-38">
          <div className="w-20 h-20 flex-shrink-0 bg-garden-bg rounded-full flex items-center justify-center text-4xl shadow-inner border border-garden-light/30" data-id="element-39">
            🔒
          </div>
          <div className="text-center sm:text-left" data-id="element-40">
            <h2 className="font-serif text-2xl font-black text-[#1A1A1A] uppercase mb-2 tracking-wide" data-id="element-41">
              Garantía sin riesgo
            </h2>
            <p className="text-lg text-gray-600 font-medium max-w-xl leading-relaxed" data-id="element-42">
              Probalo durante 7 días. Si no lográs claridad para empezar tu
              huerta, te devolvemos el 100% del dinero.{' '}
              <span className="font-bold text-garden-dark bg-garden-bg px-2 py-0.5 rounded" data-id="element-43">
                Sin preguntas.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}